export default __webpack_public_path__ + "static/media/Walmart.ce1b6ec9.svg";